module.exports = __webpack_public_path__ + "static/media/tecnico-perfeito.3eea3783.jpg";